/**
 * Labstep
 *
 * @module core/DocumentHead
 * @desc Manages document head. Wrapper around react-helmet
 */

import type React from 'react';
import { Helmet } from 'react-helmet';
import type { IDocumentHeadProps } from './types';

export const DocumentHead: React.FC<IDocumentHeadProps> = ({
  title,
}) => (
  <Helmet>
    <title>{title}</title>
  </Helmet>
);
